import { ISubscriptionPlan, SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

export const checkIsHighestSubscription = (currentSubscriptionPlan: ISubscriptionPlan | undefined) => {
  return currentSubscriptionPlan === SUBSCRIPTION_PLAN.STANDARD;
};

export const checkIsLightOrStandardSubscription = (currentSubscriptionPlan: ISubscriptionPlan | undefined) => {
  return currentSubscriptionPlan === SUBSCRIPTION_PLAN.STANDARD || currentSubscriptionPlan === SUBSCRIPTION_PLAN.LIGHT;
};
